import { useRef, useState } from 'react'
import { insertCompressedImage } from '@/lib/richTextImages'

/**
 * Toolbar control: pick an image file and insert into the TipTap editor.
 */
export function ImageToolbarButton({ editor, disabled, onError, ToolbarButton }) {
  const inputRef = useRef(null)
  const [busy, setBusy] = useState(false)
  const Button = ToolbarButton

  async function onPick(e) {
    const file = e.target.files?.[0]
    e.target.value = ''
    if (!file || !editor) return
    setBusy(true)
    const err = await insertCompressedImage(editor, file)
    setBusy(false)
    if (err) onError?.(err)
  }

  return (
    <>
      <Button
        disabled={disabled || busy || !editor}
        onClick={() => inputRef.current?.click()}
      >
        {busy ? 'Image…' : 'Image'}
      </Button>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="sr-only"
        tabIndex={-1}
        onChange={onPick}
      />
    </>
  )
}
